import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "./config";

interface QueryParams {
  keyword?: string;
  status?: string;
  date?: string;
  type?: string;
  page?: number;
  limit?: number;
  [key: string]: string | number | undefined;
}

const buildQueryParams = (params: QueryParams) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (params[key]) {
      queryParams.append(key, params[key] as string);
    }
  });
  return queryParams.toString();
};

export const useFetchTenders = ({
  keyword,
  status,
  date,
  type,
  page,
  limit,
}: QueryParams) => {
  return useQuery({
    queryKey: ["tenders", { keyword, status, date, type, page, limit }],
    queryFn: () => {
      const queryParams = buildQueryParams({
        keyword,
        status,
        date,
        type,
        page,
        limit,
      });
      return axiosInstance.get(`tenders?${queryParams}`);
    },
    enabled: Boolean(keyword || status || date || type || page || limit),
  });
};

export const useFetchTenderDetail = (tenderId: number) => {
  return useQuery({
    queryKey: ["tender-detail", tenderId],
    queryFn: () => axiosInstance.get(`tenders/${tenderId}`),
  });
};

const fetchOpportunitiesCount = async (type: string) => {
  const queryParams = buildQueryParams({
    type,
  });
  const response = await axiosInstance.get(`tender-counts?${queryParams}`);
  return response.data;
};

export const useFetchOpportunitiesCount = () => {
  return useQuery({
    queryKey: ["opportunitiesCount"],
    queryFn: async () => {
      const [totalTendersCount, totalQuotationsCount] = await Promise.all([
        fetchOpportunitiesCount("1"),
        fetchOpportunitiesCount("2"),
      ]);

      const totalOpportunitiesCount =
        totalTendersCount.all + totalQuotationsCount.all;

      return {
        totalTendersCount,
        totalQuotationsCount,
        totalOpportunitiesCount,
      };
    },
  });
};
